import { EMainProductCodeType } from '../config/company';

export interface IAuthUserDetails {
  source: string;
  metatraderId: number;
  metatraderGroup: string;
  isDemo: boolean;
  traderSubscription: string;
  marketSubscription: string;
  tenantId: string;
  mainProductCode: EMainProductCodeType;
  omsServerId: string;
}

export enum ELoginSource {
  WEB = 'WEB',
  IOS_APP = 'IOS_APP',
  MOBILE_WEB = 'MOBILE_WEB',
  DESKTOP_APP = 'DESKTOP_APP',
  ANDROID_APP = 'ANDROID_APP'
}

export enum ELoginMethod {
  PASSWORD = 0,
  EMAIL = 1,
  SMS = 2
}

export interface ILoginParams {
  userId: string;
  source: ELoginSource;
  password: string;
  deviceId?: string;
  browserType?: string;
  deviceType?: string;
  loginType?: ELoginMethod; // otpEnabled
}

export interface ILoginResponse {
  token: string;
  user: IAuthUserDetails;
}

export interface ILoginErrorResponse {
  lockedUntil?: number;
}
